import React, { Component } from 'react';
import { connect } from 'react-redux';
import AppConfig from '../../AppConfig';
import * as actions from '../../store/actions';

import AppApiUrl from '../../api/AppApiUrl';
import './style.scss';

import {
  getViewMode,
  getLoginPopupVisibility,
  getBookId,
  getIsWidget,

} from '../../store/selectors/selectors'
import {isIFrame} from "../../tools/utils";

class LoginPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
      widgetData: null,
      showBooks: false,
      showSubs: false
    }
  };

  onBuyNow(e) {
    e.preventDefault();
    const {
      bookId,
      isPremium,
      demoButtonUrl,
      privateChannel,
    } = this.props;
    this.onHide();
    if ((isPremium || privateChannel) && demoButtonUrl) {
      window.open(demoButtonUrl, '_blank');
    } else if (demoButtonUrl === '') {
      this.onHide();
    } else {
      window.open(AppApiUrl.getWebDomain() + '/store/buy-book/' + (bookId == 1 ? '01' : bookId), '_blank'); // strange hack around book ID 1
    }
  }

  onSubmit(e) {
    e.preventDefault();
    this.onHide();
    window.open(AppApiUrl.getWebDomain() + '/user/login#signin', '_blank');
  }

  onHide = () => {
    this.props.toggleLoginPopup(false);
  };

  render() {

    const {
      isLogged,
      isWidget,
      viewMode,
      isPremium,
      demoButtonText,
      privateChannel
    } = this.props;
    return (
      <div className={`modal-viewer ${this.props.isVisible && isIFrame() ? '' : 'hidden'} `}>
        <div className={`modal-viewer__body ${isLogged ? 'small' : ''} `}>


          <button
            onClick={this.onHide}
            className="modal-viewer__close"
          />



          {isWidget
            ? <h2 className="modal-viewer__heading">END OF THIS<br />SAMPLE</h2>
            : <h2 className="modal-viewer__heading">END OF THIS<br />SAMPLE CINE-BOOK</h2>
          }

          <span>
            {isWidget
              ? 'Enjoyed it'
              : 'Enjoyed the sample?'
            }
          </span>

          <button
            className="modal-viewer__btn cb-btn-viewer cb-btn-viewer--danger"
            onClick={(e) => this.onBuyNow(e)}
          >
            {isWidget
              ? `Continue ${viewMode === 'audio' ? 'Listening' : 'Watching'} `
              : isPremium || privateChannel
                ? demoButtonText
                : 'Buy now'
            }
          </button>

          <div className={`line-title ${!isLogged ? '' : 'hidden'} `}>
            or
          </div>

          {!isLogged &&
            <button
              className="modal-viewer__btn cb-btn-viewer cb-btn-viewer--danger"
              onClick={(e) => this.onSubmit(e)}
            >
              Log in
            </button>
          }

          {!isLogged &&
            <div className="text" style={{ marginTop: '8px' }}>
              if it's already yours
            </div>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    viewMode: getViewMode(state),
    isVisible: getLoginPopupVisibility(state),
    bookId: getBookId(state),
    isPremium: state.book.bookInfo.isPremium,
    isLogged: state.book.isLogged,
    isWidget: getIsWidget(state),
    demoButtonUrl: state.book.demoButtonUrl,
    demoButtonText: state.book.demoButtonText,
    privateChannel: state.book.privateChannel
  }
};

export default connect(mapStateToProps, actions)(LoginPopup)


// WEBPACK FOOTER //
// ./src/containers/login-popup/LoginPopup.jsx